import React from 'react'
import { useFeatures } from 'sb-hooks'
import { constants } from 'common/helpers'

import PayPalPaymentButtonNew from './PayPalPaymentButtonNew'
import PayPalPaymentButtonOld from './PayPalPaymentButtonOld'


const PayPalPaymentButton = (props) => {
  const { [constants.features.newPayPalSDKIntegration]: isNewPayPalSDKIntegrationEnabled } = useFeatures()

  return (
    React.createElement(isNewPayPalSDKIntegrationEnabled ? PayPalPaymentButtonNew : PayPalPaymentButtonOld, props)
  )
}


export default PayPalPaymentButton
